import type { ReactNode } from 'react'
import { ACCESSORIES } from './layers/accessories'
import { BACKGROUNDS } from './layers/backgrounds'
import { FACES } from './layers/faces'
import { FACIAL_HAIR } from './layers/facialHair'
import { FRAMES } from './layers/frames'
import { HAIR } from './layers/hair'
import { HEADGEAR } from './layers/headgear'

/**
 * Registre de rendu des items cosmétiques — ASSEMBLEUR. Les renderers
 * vivent dans ./layers/* (un fichier par couche, blason regroupé) ; ce
 * fichier porte les types partagés et recompose les maps. Chaque clé du
 * catalogue backend (front/src/components/game/cosmetics/catalog.json,
 * régénéré par `make cosmetics-catalog`) DOIT avoir son renderer dans la
 * couche correspondante — bijection gardée par registry.test.ts (Tâche 13).
 * Style : « peint vectoriel » (dégradés doux, lumière haut-gauche, rim
 * light doré #E5CC8F), ancres anatomiques du plan Lot 1.
 *
 * ⚠️ Les fichiers de layers importent UNIQUEMENT des types depuis ce
 * module (`import type` → effacé à la compilation, pas de cycle runtime).
 */
export interface LayerCtx {
  /** Préfixe unique par instance pour les ids de gradients (useId). */
  uid: string
}

export type LayerRenderer = (ctx: LayerCtx) => ReactNode

export type AvatarSlot = 'face' | 'hair' | 'facialHair' | 'headgear' | 'accessory' | 'background' | 'frame'

/** Palette de blason : field = champ (2 tons), chief = chef, glyph = trait de l'emblème. */
export interface BlasonPalette {
  field: [string, string]
  chief: [string, string]
  glyph: string
  accent: string
}

export const AVATAR_LAYERS: Record<AvatarSlot, Record<string, LayerRenderer>> = {
  background: BACKGROUNDS,
  face: FACES,
  facialHair: FACIAL_HAIR,
  hair: HAIR,
  headgear: HEADGEAR,
  accessory: ACCESSORIES,
  frame: FRAMES,
}

export { BLASON_FIELDS, BLASON_GLYPHS, BLASON_PALETTES, BLASON_SHAPES } from './layers/blason'
